import { useMutation } from "@tanstack/react-query";
import { axios } from "./axios";
import { useAuth } from "../context/AuthContext";
import { env } from "../utils/env";

interface Params {
  name: string;
  _type: string;
  order: number;
  active?: boolean;
}

export const useEditAddressType = () => {
  const { authHeader } = useAuth();

  return useMutation(({ params, id }: { params: Params; id: number }) => {
    return axios.put(
      `${env.verifyServiceUrl}individual/address_type/${id}/`,
      params,
      {
        headers: {
          Authorization: authHeader,
        },
      }
    );
  });
};
